import { HttpClient } from "@angular/common/http";
import { Component, ElementRef } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
import { BaseComponent } from "@shared/lib/components/base.component";
import { FloatingPresence } from "@shared/lib/model/floating-presence";
import { DataService } from "@shared/lib/services/data.service";
import { FloatingPresenceService } from "@shared/lib/services/floating-presence.service";
import { LocaleService } from "@shared/lib/services/locale.service";
import { TranslationMapperService } from "@shared/lib/services/translation-mapper.service";
import { UrlService } from "@shared/lib/services/url.service";
import { UsanaMarketService } from "@usana/ux/markets";
import { Observable } from "rxjs";

@Component({
  selector: 'u-share-table',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
  providers: [{provide: BaseComponent, useExisting: ShareTableComponent}]
})

export class ShareTableComponent extends BaseComponent {
  map = {
    'main-heading': 'main-heading',
    'main-paragraph': 'main-paragraph',
    'main-subheading': 'main-subheading',
    'heading1': 'heading1',
    'card1-heading-subtitle': 'card1-heading-subtitle',
    'card1-heading': 'card1-heading',
    'card1-heading-pg': 'card1-heading-pg',
    'card1-list': 'card1-list',
    'card1-btn': 'card1-btn',
    'card2-heading-subtitle': 'card2-heading-subtitle',
    'card2-heading': 'card2-heading',
    'card2-heading-pg': 'card2-heading-pg',
    'card2-list': 'card2-list',
    'card2-btn': 'card2-btn',
    'card3-heading-subtitle': 'card3-heading-subtitle',
    'card3-heading': 'card3-heading',
    'card3-heading-pg': 'card3-heading-pg',
    'card3-list': 'card3-list',
    'card3-btn': 'card3-btn',
    'card3-text': 'card3-text',
    'how-to-earn-img': 'how-to-earn-img',
    'earn-heading': 'earn-heading',
    'earn-pg': 'earn-pg',
    'earn-table-body1': 'earn-table-body1',
    'earn-table-body2': 'earn-table-body2',
    'earn-table-body3': 'earn-table-body3',
    'earn-table-body4': 'earn-table-body4',
    'earn-table-body5': 'earn-table-body5',
    'earn-table-body6': 'earn-table-body6',
    'earn-table-body7': 'earn-table-body7',
    'earn-table-body8': 'earn-table-body8',
    'earn-table-body9': 'earn-table-body9',
    'earn-table-body10': 'earn-table-body10',
    'earn-table-body11': 'earn-table-body11',
    'earn-table-body12': 'earn-table-body12',
    'earn-table-body13': 'earn-table-body13',
    'earn-table-body14': 'earn-table-body14',
    'earn-table-body15': 'earn-table-body15',
    'earn-table-body16': 'earn-table-body16',
    'earn-table-body17': 'earn-table-body17',
    'footer-heading': 'footer-heading',
    'footer-note': 'footer-note'
  }
  floatingPresence: FloatingPresence;
  lang: string;
  associateLink: Observable<string>;

  constructor(
    protected http: HttpClient,
    localeService: LocaleService,
    titleService: Title,
    metaService: Meta,
    urlService: UrlService,
    translationMapperService: TranslationMapperService,
    el: ElementRef,
    dataService: DataService,
    protected floatingPresenceService: FloatingPresenceService,
    protected usanaMarketService: UsanaMarketService,
  ) {
    super(
      http,
      localeService,
      titleService,
      metaService,
      urlService,
      translationMapperService,
      el,
      dataService);
    this.floatingPresenceService.loadFloatingPresence().then((fp: FloatingPresence) => {
      this.floatingPresence = fp;
    });
    this.usanaMarketService.geti18NInfoSubject().subscribe(i18Info => {
      this.lang = i18Info.current.phxMarketId;
    });
    this.associateLink = this.floatingPresenceService.getEnrollLink();
  }

  get preferredLink() {
    return `/ux/cart/${this.lang}/page/pc-signup`;
  }
  
  get affiliateLink() {
    return `/ux/cart/${this.lang}/page/affiliate-signup`;
  }


  get isPwp() {
    return this.floatingPresenceService.seemsLikeSubdomain();
  }
}